import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { postApi } from '../../../Services/apiService';
import { toast } from 'react-toastify';
import { PENDING_SUBSCRIPTION_ONBOARDING_KEY } from '../../../Utils/authStorage';
import { useLocation } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import './../../../Auth.css';
import AuthLeftBranding from './AuthLeftBranding';
import AuthLandingFooter from './AuthLandingFooter';
import AuthBackToHome from './AuthBackToHome';
function Register() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [phone, setPhone] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showCnfrmPassword, setShowCnfrmPassword] = useState(false);
    const [agreeToTerms, setAgreeToTerms] = useState(false);
    const [loader, setLoader] = useState(false);
    const location = useLocation();
    const role = location.state?.role; // Retrieve "role" from location state
    const navigate = useNavigate();


    useEffect(() => {
        const token = localStorage.getItem('token');
        const userDetails = localStorage.getItem('userDetail');
        const pendingOnboarding = localStorage.getItem(PENDING_SUBSCRIPTION_ONBOARDING_KEY);

        if (!token || token === 'null' || token === 'undefined' || !userDetails) {
          return;
        }

        try {
          const parsedUserDetails = JSON.parse(userDetails);
          if (pendingOnboarding === '1') {
            if (location.state?.fromSubscriptionPlans) {
              return;
            }
            navigate('/register/plans', { replace: true });
            return;
          }
          if (parsedUserDetails?.role === '1' || parsedUserDetails?.role === '2') {
            navigate('/user/dashboard', { replace: true });
          }
        } catch (error) {
          console.error('Error parsing user details:', error);
        }
      }, [navigate, location.state?.fromSubscriptionPlans]);
    console.log('this is role', role);
    const [errors, setErrors] = useState({
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
        phoneNumber: '',
        countryCode: '',
        terms: ''
    });

    const handleRegister = async () => {
        console.log('=== SIGNUP FORM SUBMISSION ===');
        console.log('Form values:', { name, email, phone, password, confirmPassword, agreeToTerms });
        
        const isValid = validateForm();
        console.log('Validation result:', isValid);
        
        if (isValid) {
            const roleId = role === 'user' ? '1' : '2';
            const fullPhone = phone.replace(/\s/g, '');
            const extractedCountryCode = '+' + fullPhone.match(/^\d{1,4}/)?.[0] || '1';
            const extractedPhoneNumber = fullPhone.replace(/^\d{1,4}/, '');

            const insertData = {
                name,
                email,
                password,
                phone_number: extractedPhoneNumber,
                country_code: extractedCountryCode,
                role: roleId,
                authentication_type: '1',
            };

            setLoader(true);
            (async () => {
                try {
                    const response = await postApi('/auth/register', insertData);
                    /** API: { statusCode, message, user_details: { id, name, email, country_code, phone_number, token } } */
                    const body =
                        response?.user_details != null
                            ? response
                            : response?.data != null && typeof response.data === 'object'
                              ? response.data
                              : response;
                    const statusCode = body?.statusCode;
                    const userDetails = body?.user_details;
                    const token = userDetails?.token ?? userDetails?.access_token;

                    if (statusCode === 200 && userDetails && token) {
                        localStorage.setItem('userDetail', JSON.stringify(userDetails));
                        localStorage.setItem('token', JSON.stringify(token));
                        localStorage.setItem(PENDING_SUBSCRIPTION_ONBOARDING_KEY, '1');
                        toast.success(body?.message || response?.message || 'Account created. Choose your plan next.');
                        navigate('/register/plans', { state: role ? { role } : undefined });
                        setErrors({
                            name: '',
                            email: '',
                            password: '',
                            confirmPassword: '',
                            phoneNumber: '',
                            countryCode: '',
                        });
                    } else if (statusCode === 200 && userDetails && !token) {
                        toast.error('Account created but no token was returned. Please try logging in.');
                    } else if (statusCode === 400) {
                        toast.error(body?.message || response?.message || 'Email already exists');
                    } else {
                        toast.error(body?.message || response?.message || 'Registration failed');
                    }
                } catch (error) {
                    toast.error(
                        error?.response?.data?.message || error?.message || 'Registration failed. Please try again.'
                    );
                } finally {
                    setLoader(false);
                }
            })();
        } else {
            console.log('❌ Validation failed - API will not be called');
            console.log('Validation errors:', errors);
        }
    };

    const validateForm = () => {
        const validationErrors = {};

        console.log('Validating form...');
        
        if (!name) {
            validationErrors.name = 'Name is required.';
            console.log('❌ Name validation failed');
        }
        
        if (!email) {
            validationErrors.email = 'Email is required.';
            console.log('❌ Email validation failed: empty');
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            validationErrors.email = 'Email is invalid.';
            console.log('❌ Email validation failed: invalid format');
        }
        
        // Fix: Phone validation - remove spaces and check length properly
        const cleanPhone = phone.replace(/\s/g, '').replace(/[^0-9]/g, '');
        if (!phone) {
            validationErrors.phoneNumber = 'Phone number is required.';
            console.log('❌ Phone validation failed: empty');
        } else if (cleanPhone.length < 7) {
            validationErrors.phoneNumber = 'Phone number is too short.';
            console.log('❌ Phone validation failed: too short', cleanPhone.length);
        }
        
        if (!password.trim()) {
            validationErrors.password = 'Password is required.';
            console.log('❌ Password validation failed: empty');
        } else if (password.length < 6) {
            validationErrors.password = 'Password must be at least 6 characters.';
            console.log('❌ Password validation failed: too short');
        }
        
        if (!confirmPassword.trim()) {
            validationErrors.confirmPassword = 'Confirm password is required.';
            console.log('❌ Confirm password validation failed: empty');
        } else if (confirmPassword !== password) {
            validationErrors.confirmPassword = 'Passwords do not match.';
            console.log('❌ Confirm password validation failed: mismatch');
        }
        
        if (!agreeToTerms) {
            validationErrors.terms = 'You must agree to the Terms and Privacy Policy.';
            console.log('❌ Terms validation failed: not checked');
        }

        setErrors(validationErrors);
        
        const isValid = Object.keys(validationErrors).length === 0;
        console.log('Validation complete. Errors found:', Object.keys(validationErrors).length);
        if (!isValid) {
            console.log('Validation errors:', validationErrors);
        }
        
        return isValid;
    };

    useEffect(() => {
        if (password && confirmPassword && password !== confirmPassword) {
            setErrors(prevErrors => ({
                ...prevErrors,
                confirmPassword: 'Passwords do not match.'
            }));
        } else {
            setErrors(prevErrors => ({
                ...prevErrors,
                confirmPassword: ''
            }));
        }
    }, [password, confirmPassword]);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    const toggleCnfrmPasswordVisibility = () => {
        setShowCnfrmPassword(!showCnfrmPassword);
    };

    const signupDescription =
        role === 'user'
            ? 'Create your account to join your family on Fam Connect and stay connected.'
            : 'Register as a family administrator to begin setting up your family tree with the names for the start/top of your line (in most cases the grandparents) and their children. You will be tasked with assigning a color for each of those children associated with the start/top of the line. Each line will have their own unique color that will carry down to everyone in that line. This will begin the process of building your family tree and keeping track of pertinent data that can be useful for generations to come.';

    return (
        <div className="login-main login-main--landing-footer">
            <div className="login-main-split">
            {/* Left Side - Logo/Image */}
            <div className="left-div">
                <AuthBackToHome placement="bluePanel" />
                <AuthLeftBranding />
            </div>

            {/* Right Side - Form */}
            <div className="login-container signup-plans-left" 
            >
                <h2>Sign Up</h2>
                <h4 className="signup-description">{signupDescription}</h4>
                <form onSubmit={(e) => {
                    e.preventDefault();
                    handleRegister();
                }}>
                    {/* Name */}
                    <div className="form-group">
                        <label htmlFor="name" className="required-label">Name</label>
                        <input
                            id="name"
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                            className={`form-control ${errors.name ? 'input-error' : ''}`}
                            placeholder="Enter your name"
                        />
                        {errors.name && (
                            <div className="error-message" style={{ 
                                color: '#dc3545', 
                                fontSize: '12px', 
                                marginTop: '5px',
                                display: 'block'
                            }}>
                                {errors.name}
                            </div>
                        )}
                    </div>

                    {/* Email */}
                    <div className="form-group">
                        <label htmlFor="email" className="required-label">Email</label>
                        <input
                            id="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            className={`form-control ${errors.email ? 'input-error' : ''}`}
                            placeholder="Enter your email"
                        />
                        {errors.email && (
                            <div className="error-message" style={{ 
                                color: '#dc3545', 
                                fontSize: '12px', 
                                marginTop: '5px',
                                display: 'block'
                            }}>
                                {errors.email}
                            </div>
                        )}
                    </div>

{/* Phone with Country Code */}
                    <div className="form-group">
                        <label htmlFor="phoneNumber" className="required-label">Phone</label>
                        <PhoneInput
                            country={'us'}
                            value={phone}
                            onChange={setPhone}
                            inputClass={`form-control ${errors.phoneNumber ? 'input-error' : ''}`}
                            containerClass="phone-input-container"
                            buttonClass="country-dropdown-button"
                            dropdownClass="country-dropdown"
                            searchClass="country-search"
                            enableSearch={true}
                            searchPlaceholder="Search country"
                            placeholder="Enter phone number"
                        />
                        {errors.phoneNumber && (
                            <div className="error-message" style={{ 
                                color: '#dc3545', 
                                fontSize: '12px', 
                                marginTop: '5px',
                                display: 'block'
                            }}>
                                {errors.phoneNumber}
                            </div>
                        )}
                    </div>

                    {/* Password */}
                    <div className="form-group">
                        <label htmlFor="password" className="required-label">Password</label>
                        <div className="password-wrapper">
                            <input
                                id="password"
                                type={showPassword ? 'text' : 'password'}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                className={`form-control ${errors.password ? 'input-error' : ''}`}
                                placeholder="Enter password"
                            />
                            <span className="eye-icon" onClick={togglePasswordVisibility}>
                                <img
                                    src={
                                        showPassword
                                            ? window.getPublicUrl('/assets/images/Eye.svg')
                                            : window.getPublicUrl('/assets/images/Eye-closed.svg')
                                    }
                                    alt="Toggle Password"
                                />
                            </span>
                        </div>
                        {errors.password && (
                            <div className="error-message" style={{ 
                                color: '#dc3545', 
                                fontSize: '12px', 
                                marginTop: '5px',
                                display: 'block'
                            }}>
                                {errors.password}
                            </div>
                        )}
                    </div>

                    {/* Confirm Password */}
                    <div className="form-group">
                        <label htmlFor="confirmPassword" className="required-label">Confirm Password</label>
                        <div className="password-wrapper">
                            <input
                                id="confirmPassword"
                                type={showCnfrmPassword ? 'text' : 'password'}
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                                className={`form-control ${errors.confirmPassword ? 'input-error' : ''}`}
                                placeholder="Confirm password"
                            />
                            <span className="eye-icon" onClick={toggleCnfrmPasswordVisibility}>
                                <img
                                    src={
                                        showCnfrmPassword
                                            ? window.getPublicUrl('/assets/images/Eye.svg')
                                            : window.getPublicUrl('/assets/images/Eye-closed.svg')
                                    }
                                    alt="Toggle Password"
                                />
                            </span>
                        </div>
                        {errors.confirmPassword && (
                            <div className="error-message" style={{ 
                                color: '#dc3545', 
                                fontSize: '12px', 
                                marginTop: '5px',
                                display: 'block'
                            }}>
                                {errors.confirmPassword}
                            </div>
                        )}
                    </div>

                    {/* Terms and Privacy Policy Checkbox */}
                    <div className="form-extra form-extra--terms">
                        <label className="remember-me">
                            <input
                                type="checkbox"
                                checked={agreeToTerms}
                                onChange={(e) => setAgreeToTerms(e.target.checked)}
                            />
                            <span className="remember-me-text">
                                By signing up, you agree to our{' '}
                                <Link to="/terms" className="link-text">Terms</Link>
                                {' '}and{' '}
                                <Link to="/privacy" className="link-text">Privacy Policy</Link>
                            </span>
                        </label>
                    </div>
                    {errors.terms && (
                        <div className="error-message" style={{ 
                            color: '#dc3545', 
                            fontSize: '12px', 
                            marginTop: '5px',
                            display: 'block'
                        }}>
                            {errors.terms}
                        </div>
                    )}

                    <Button variant="primary" type="submit" className='login-btn' disabled={loader}>
                        {loader ? 'Creating account…' : 'Sign Up'}
                    </Button>
                </form>

                <div className="signup-bottom signup-bottom--register">
                    <span>Already have an account? </span>
                    <Link to="/login" className="signup-link">
                        Log in
                    </Link>
                </div>
            </div>
            </div>

            <AuthLandingFooter />
        </div>
    );
}

export default Register;
